// extracted by mini-css-extract-plugin
export default {"inputContainer":"inputContainer__oDPEy","input":"input__fEcN4","suffix":"suffix__KxQV+"};